const PROVIDER_NAME_NOT_FOUND = 'Name unavailable. Pricing still valid if MedicareID is valid.';

export {
    PROVIDER_NAME_NOT_FOUND
}